import { computed } from 'vue'
import { useStore } from 'vuex'

export function useStoreGetters(getterNames) {
  const store = useStore();
  const getters = {};

  getterNames.forEach(name => {
    const computedGetter = computed(() => store.getters[name]);
    getters[name] = computedGetter.value;
  });

  return getters;
}

// Méthode pour obtenir des getters réactifs
export function useReactiveStoreGetters(getterNames) {
  const store = useStore();
  const getters = {};

  getterNames.forEach(name => {
    getters[name] = computed(() => store.getters[name]);
  });

  return getters;
}
